import { HttpContextToken } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { IMockArgs } from '../model';
import { MockConfig } from '../model/mock.model';

export const MOCK_CONFIG = new InjectionToken<MockConfig>('MOCK_CONFIG');
export const MOCK_CONTEXT = new HttpContextToken<any>(<T>() => ({}));
